import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import "./styles/style.scss";

const ButtonsGroup = ({ align, direction, ...rest }) => {
  /**
   * Вернуть класс, применяемый для позиционирования
   *
   * @param {String} value
   * @return {String}
   */
  const getAlignClass = value => {
    const classes = {
      left: "buttons-group--left",
      right: "buttons-group--right",
      center: "buttons-group--center",
    };

    return _.get(classes, value, ButtonsGroup.defaultProps.align);
  };

  /**
   * Вернуть класс, применяемый для позиционирования
   *
   * @param {String} value
   * @return {String}
   */
  const getDirectionClass = value => {
    const classes = {
      row: "buttons-group--row",
      column: "buttons-group--column",
    };

    return _.get(classes, value, ButtonsGroup.defaultProps.direction);
  };

  const classNames = `${[
    "buttons-group",
    getAlignClass(align),
    getDirectionClass(direction),
    rest.className,
  ]
    .filter(name => name)
    .join(" ")}`;

  return <div className={classNames}>{rest.children}</div>;
};

ButtonsGroup.propTypes = {
  align: PropTypes.string,
  direction: PropTypes.string,
};

ButtonsGroup.defaultProps = {
  align: "left",
  direction: "row",
};

export default ButtonsGroup;
